import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

declare var google: any;

@Component({
  selector: 'app-location-search',
  templateUrl: './location-search.component.html',
  styleUrls: ['./location-search.component.scss'],
  standalone: false
})


export class LocationSearchComponent implements OnInit {

  @Input() height = '24vh'

  @Input() location_lat
  @Input() location_lon

  @Output() onSelected = new EventEmitter<any>();

  @Input() showMap = true;


  @Input() disabled: boolean = false;

  loc: any = {}



  marker: any;
  autocomplete: any;

  @ViewChild('input', { static: true }) input: ElementRef;
  @ViewChild('mapcnt', { static: true }) mapcnt: ElementRef;

  constructor(
  ) {
  }

  ngOnInit() {

    this.initMapAndAutocomplete()

  }


  map;



  initMapAndAutocomplete() {

    // Inizializza la mappa
    const center = { lat: this.location_lat || 0, lng: this.location_lon || 0 };
    this.map = new google.maps.Map(this.mapcnt.nativeElement, {
      center,
      zoom: 12,
      scrollwheel: true,
      gestureHandling: 'auto'
    });

    this.marker = new google.maps.Marker({
      position: center,
      map: this.map
    });

    this.autocomplete = new google.maps.places.Autocomplete(this.input.nativeElement, {
      types: ['geocode'], // solo indirizzi
      componentRestrictions: { country: 'it' }
    });

    this.autocomplete.addListener('place_changed', () => {

      this.selection()

    });
  }


  selection() {
    try {

      //console.clear()
      console.log('place_changed event triggered');

      const place = this.autocomplete.getPlace();
      console.log('place: ', place);

      const addressComponents = place.address_components;

      this.loc = {
        Prov: this.extract(addressComponents, 'administrative_area_level_2'),
        Citta: this.extract(addressComponents, 'locality'),
        CAP: this.extract(addressComponents, 'postal_code'),
        Indirizzo: this.extract(addressComponents, 'route') + ' ' + this.extract(addressComponents, 'street_number'),

        location_lat: place.geometry.location.lat(),
        location_lon: place.geometry.location.lng(),
        response: place
      };

      console.log('emit', this.loc)
      this.onSelected.emit(this.loc);



      if (!place.geometry) return;

      this.map.setCenter(place.geometry.location);
      this.marker.setPosition(place.geometry.location);


    } catch (error) {
      console.error('Error in place_changed listener: ', error);


    }
  }


  extract(components, type, short = true) {

    try {
      const data = components.find(x => x.types.includes(type));
      console.log('data: ', data);
      return data[short ? 'short_name' : 'long_name']

    } catch (error) {
      console.log('error: ', error);
      return ''
    }


  }




}
